// frontend/src/components/MainLayout/MainLayout.tsx

import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import './MainLayout.css';
import logoCcomex from '../../assets/logo-completa.png';
import { useAuth } from '../../hooks/useAuth'; // <-- 1. Importa o nosso hook

export const MainLayout = () => {
  const navigate = useNavigate();
  const auth = useAuth(); // <-- 2. Usa o hook para pegar as informações do usuário

  const handleLogout = () => {
    localStorage.removeItem('ccomex_token');
    navigate('/login');
  };

  return (
    <div className="main-layout">
      <header className="main-header">
        <div className="logo-container">
          <img src={logoCcomex} alt="CCOMEX Logo" className="header-logo" />
        </div>
        <nav className="main-nav">
          <NavLink to="/dashboard">Dashboard</NavLink>
          <NavLink to="/fora-kit">Fora Kit</NavLink>
          <NavLink to="/ia">IA</NavLink>
          {/* 3. Renderização condicional: mostra o link apenas se o role for 'master' */}
          {auth.role === 'master' && (
            <NavLink to="/input">Input</NavLink>
          )}
        </nav>
        <div className="user-actions">
          <button onClick={handleLogout} className="logout-button">Sair</button>
        </div>
      </header>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};